import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import moment from 'moment';

import LineItem from '_views/lineItem';
import {
  getIsActiveAndNotExpiredLicensePool,
  getIsLicensePoolWithCount,
  getLicensePoolProductLabel,
  getLicensePoolSublicensesLabelWithPrefix
} from '_utils/licensePools';
import { formatDate } from '_utils';
import { LICENSE_POOL_TYPES } from '../../server/constants';

const El = ({
  label,
  text,
  count
}) => count
  ? (
    <div>
      <b style={{color: 'grey', paddingRight: '0.25em'}}>{label}</b><span>{text}</span>
    </div>
  ) : null

El.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired
}

const ElSeat = ({
  label,
  count
}) => <El label={label} count={count} text={`${count} ${count > 1 ? 'seats' : 'seat'}`} />

ElSeat.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired
}

const LicensePoolUsage = ({ licensePool }) => {
  if (!licensePool) return null;
  if (!getIsActiveAndNotExpiredLicensePool(licensePool)) return null;
  if (!getIsLicensePoolWithCount(licensePool)) return null;

  const acCount = licensePool.ac_count;
  const acCountUsed = licensePool.usage.activation_codes.active.total;
  const acCountAvail = R.clamp(0, acCount, acCount - acCountUsed);

  const expiry = licensePool.expires_on;

  return (
    <div style={{ marginBottom: '0.75em' }} >
      <LineItem label={ `${getLicensePoolProductLabel(licensePool)} ${getLicensePoolSublicensesLabelWithPrefix(licensePool)}` } >
        <El label='AC pool' text={ `${acCountAvail} available out of ${acCount}` } count={ acCount } />
        <ElSeat label='Key pool' count={ licensePool.key_count } />
        <ElSeat label='iLok pool' count={ licensePool.ilok_count } />
        <ElSeat label='KeyServer pool' count={ licensePool.keyserver_count } />
        {
          licensePool.type === LICENSE_POOL_TYPES.SUBSCRIPTION
            ? <El label='Expires'count={1} text={`${formatDate(expiry)} (${moment.duration(moment(expiry).diff()).humanize(true)})`} />
            : null
        }
      </LineItem>
    </div>
  );
}

LicensePoolUsage.propTypes = {
  licensePool: PropTypes.object.isRequired
}

export default LicensePoolUsage



// WEBPACK FOOTER //
// ./webAdmin/views/usage.js